const {
    permissionMainfestsXml,
    singlePermissionXMl,
    singlePermissionKt,
    permissionMethod,
    permissionStr,
} = require("../Allcode/Permission/Single_permission");
const {
    multiplAndroidManinfestXml,
    multipleActivtyXMl,
    multipleString,
    multiplePermissionMethod,
    multiplePermissionActivity,
} = require("../Allcode/Permission/Multiple_permission");
const {
    dialogActivtyXMl,
    layout_progress,
    progressActivityKt,
    layout_loading,
    loadingActivityKt,
    alertActivityKt,
    materialAlertActivityKt,
    materialThemeDialogActivityKt,
    customeDialogActivityKt,
} = require("../Allcode/Dialog/Dialog");
const {
    installedActivityXML,
    layout_installed_apps,
    installedLayoutLoadingXml,
    installedString,
    search_menuXml,
    appModel,
    appAdapter,
    installedActivityKt,
} = require("../Allcode/DisplayInstalledApps/InstalledApps");
const {
    ThemeColorXML,
    ThemeLightXML,
    ThemeDarkXML,
    ThemeActiviyMainXML,
    ThemeMainActivityKt,
    ThemeSplashXML,
    ThemeSplashActivityKt,
    ThemeAndroidMainfest,
} = require("../Allcode/Theme/APPTheme");
const {
    SimpleDatePickerActivityXMl,
    SimpleDatePickerActivityKT,
} = require("../Allcode/Date and Time Picker/SimpleDatePicker");
const {
    MaterialDatePickerActivityXMl,
    MaterialDatePickerActivityKT,
} = require("../Allcode/Date and Time Picker/MaterialDatePicker");
const {
    SimpleTimePickerActivityXMl,
    SimpleTimePickerActivityKT,
} = require("../Allcode/Date and Time Picker/SimpleTimePicker");
const {
    MaterialTimePickerActivityXMl,
    MaterialTimePickerActivityKT,
} = require("../Allcode/Date and Time Picker/MaterialTimePicker");
const {
    DownloadAndroidMainfestXMl,
    DownloadMainActivityXML,
    DownloadMainActivityKT,
} = require("../Allcode/DownloadFile/DownloadAnyFile");
const {
    SCPMainActivityXML,
    SCPMainActivityKT,
} = require("../Allcode/Share Copy and Paste text/SCP");
const {
    SBMActivityXML,
    item_layout,
    item_model,
    item_adapter,
    SBMActivityKIT,
    SBMenuXML,
} = require("../Allcode/Search/SearchBarWithMenu");

const androidManifestXML = "AndroidManifest.xml";
const stringXML = "string.xml";
const XML = "xml";
const KT = "jsx";
const colorXMl = "color.xml";
const activity_main = "activity_main.xml";
const MainActivity = "MainActivity.kt";

const sourceCodeList = [
    {
        id: "1",
        type: true,
        typeId: "permission",
        typeName: "Permission",
        subs: [
            {
                id: "1",
                component_name: "Single Run-time Pemission",
                path: "/single-run-time-permission",
                description:
                    "Runtime permissions give your app additional access to restricted data, and they allow your app to perform restricted actions that more substantially affect the system and other apps.Many runtime permissions access private user data, a special type of restricted data that includes potentially sensitive information. Examples of private user data include location and contact information. ",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [
                    androidManifestXML,
                    activity_main,
                    stringXML,
                    "Permission.kt",
                    MainActivity,
                ],
                fileType: [XML, XML, XML, KT, KT],
                fileCode: [
                    permissionMainfestsXml,
                    singlePermissionXMl,
                    permissionStr,
                    permissionMethod,
                    singlePermissionKt,
                ],
            },
            {
                id: "2",
                component_name: "Multiple Run-time Permission",
                path: "/multiple-run-time-permission",
                description: "To request Multiple Runtime Permissions in our application. This type of request can be made through various types of application who wanted to access different type of content after accessing user permission.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [
                    androidManifestXML,
                    activity_main,
                    stringXML,
                    "Permission.kt",
                    MainActivity,
                ],
                fileType: [XML, XML, XML, KT, KT],
                fileCode: [
                    multiplAndroidManinfestXml,
                    multipleActivtyXMl,
                    multipleString,
                    multiplePermissionMethod,
                    multiplePermissionActivity,
                ],
            },
        ],
    },
    {
        id: "2",
        type: true,
        typeId: "dialog",
        typeName: "Dialog",
        subs: [
            {
                id: "1",
                component_name: "Progress Dialog",
                path: "/progress-dialog",
                description: "A dialog showing a progress indicator and an optional text message or view. Only a text message or a view can be used at the same time.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, "layout_progress.xml", MainActivity],
                fileType: [XML, XML, KT],
                fileCode: [dialogActivtyXMl, layout_progress, progressActivityKt],
            },
            {
                id: "2",
                component_name: "Loading Dialog",
                path: "/loading-dialog",
                description: "A dialog showing a progress indicator and an optional text message or view. Only a text message or a view can be used at the same time.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, "layout_loading.xml", MainActivity],
                fileType: [XML, XML, KT],
                fileCode: [dialogActivtyXMl, layout_loading, loadingActivityKt],
            },
            {
                id: "3",
                component_name: "Alert Dialog",
                path: "/alert-dialog",
                description: "AlertDialog can be used to display the dialog message with OK and Cancel buttons. It can be used to interrupt and ask the user about his/her choice to continue or discontinue.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [dialogActivtyXMl, alertActivityKt],
            },
            {
                id: "4",
                component_name: "Material Alert Dialog",
                path: "/material-alert-dialog",
                description: "Material Alert Dialog can be used to display the dialog message with OK and Cancel buttons. It can be used to interrupt and ask the user about his/her choice to continue or discontinue.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [dialogActivtyXMl, materialAlertActivityKt],
            },
            {
                id: "5",
                component_name: "Material Theme Dialog",
                path: "/material-theme-dialog",
                description: "Material Theme Dialog with the Single Item Selectio",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [dialogActivtyXMl, materialThemeDialogActivityKt],
            },
            {
                id: "6",
                component_name: "Custom Dialog",
                path: "/custom-dialog",
                description: "The custom layout fills the dialog.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [dialogActivtyXMl, customeDialogActivityKt],
            },
        ],
    },
    {
        id: "3",
        type: false,
        component_name: "Display Installed Apps",
        path: "/display-installed-apps",
        description: "display all installed android applications and pick one to run and open app info.",
        youtube_short_url: null,
        youtube_url: null,
        fileName: [
            activity_main,
            "layout_installed_app.xml",
            stringXML,
            "layout_loading.xml",
            "search_menu.xml",
            "AppModel.kt",
            "AppAdapter.kt",
            MainActivity,
        ],
        fileType: [XML, XML, XML, XML, XML, KT, KT, KT],
        fileCode: [
            installedActivityXML,
            layout_installed_apps,
            installedLayoutLoadingXml,
            installedString,
            search_menuXml,
            appModel,
            appAdapter,
            installedActivityKt,
        ],
    },
    {
        id: "4",
        type: false,
        component_name: "Theme",
        path: "/theme",
        description: "Set light and dark theme using shared Preferences",
        youtube_short_url: null,
        youtube_url: null,
        fileName: [
            colorXMl,
            "themes.xml(light)",
            "themes.xml(night)",
            activity_main,
            MainActivity,
            "activity_splash.xml",
            "SplashActivity.kt",
            androidManifestXML,
        ],
        fileType: [XML, XML, XML, XML, KT, XML, KT, XML],
        fileCode: [
            ThemeColorXML,
            ThemeLightXML,
            ThemeDarkXML,
            ThemeActiviyMainXML,
            ThemeMainActivityKt,
            ThemeSplashXML,
            ThemeSplashActivityKt,
            ThemeAndroidMainfest,
        ],
    },
    {
        id: "5",
        type: true,
        typeId: "datePicker",
        typeName: "Date Picker",
        subs: [
            {
                id: "1",
                component_name: "Simple Date Picker",
                path: "/simple-date-picker",
                description: "Simple Date Picker is to select a date from a calendar",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [SimpleDatePickerActivityXMl, SimpleDatePickerActivityKT],
            },
            {
                id: "2",
                component_name: "Material Date Picker",
                path: "/material-date-picker",
                description: "Material Date Picker is to select a date from a calendar",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [MaterialDatePickerActivityXMl, MaterialDatePickerActivityKT],
            },
        ],
    },
    {
        id: "6",
        type: true,
        typeId: "timePicker",
        typeName: "Time Picker",
        subs: [
            {
                id: "1",
                component_name: "Simple Time Picker",
                path: "/simple-time-picker",
                description: "Simple Time picker allow users to enter a specific time value.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [SimpleTimePickerActivityXMl, SimpleTimePickerActivityKT],
            },
            {
                id: "2",
                component_name: "Material Time Picker",
                path: "/material-time-picker",
                description: "Material Time picker allow users to enter a specific time value.",
                youtube_short_url: null,
                youtube_url: null,
                fileName: [activity_main, MainActivity],
                fileType: [XML, KT],
                fileCode: [MaterialTimePickerActivityXMl, MaterialTimePickerActivityKT],
            },
        ],
    },
    {
        id: "7",
        type: false,
        component_name: "Download File",
        path: "/download-file",
        description: "Download any file form url.",
        youtube_short_url: null,
        youtube_url: null,
        fileName: [androidManifestXML, activity_main, MainActivity],
        fileType: [XML, XML, KT],
        fileCode: [
            DownloadAndroidMainfestXMl,
            DownloadMainActivityXML,
            DownloadMainActivityKT,
        ],
    },
    {
        id: "8",
        type: false,
        component_name: "Share, Copy & Paste Text",
        path: "/share-copy-paste-text",
        description: "Share is used when sending data to another app. Android provides a powerful clipboard-based framework for copying and pasting",
        youtube_short_url: null,
        youtube_url: null,
        fileName: [activity_main, MainActivity],
        fileType: [XML, KT],
        fileCode: [SCPMainActivityXML, SCPMainActivityKT],
    },
    {
        id: "9",
        type: false,
        component_name: "Search Bar With Menu",
        path: "/search-bar-with-menu",
        description: "search functionality with default ActionBar.",
        youtube_short_url: null,
        youtube_url: null,
        fileName: [
            activity_main,
            "search_menu.xml",
            "item_layout.xml",
            "ItemModel.kt",
            "ItemAdapter.kt",
            MainActivity,
        ],
        fileType: [XML, XML, XML, KT, KT, KT],
        fileCode: [
            SBMActivityXML,
            SBMenuXML,
            item_layout,
            item_model,
            item_adapter,
            SBMActivityKIT,
        ],
    },
];

module.exports = { sourceCodeList: sourceCodeList };
